export default {
    //保育園
    0:22.3,
    1:22.3,
    2:22.3,
    3:22.3,

    //幼稚園
    4:22.3,
    5:22.3,
    6:22.3,

    //小学生
    7: 32.1,
    8: 32.1,
    9: 32.1,
    10: 32.1,
    11: 32.1,
    12: 32.1,

    //中学生
    13:48.8,
    14:48.8,
    15:48.8,

    //高校生
    16:45.7,
    17:45.7,
    18:45.7,

    //大学生
    19:157.3+89.7,
    20:157.3,
    21:157.3,
    22:157.3,
}